import { render, staticRenderFns } from "./ReportClosure.vue?vue&type=template&id=4d9fc5d8&"
import script from "./ReportClosure.vue?vue&type=script&lang=js&"
export * from "./ReportClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports